import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-badge',
	templateUrl:'./WaBadgePage.html',
	styles: [],
	styleUrls:['./WaBadgePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaBadgePage
{
	mdContent_276 = `\`\`\`java
import com.jwebmp.webawesome.components.badge.WaBadge;
\`\`\``;
	mdContent_277 = `\`\`\`java
var badge = new WaBadge<>();
badge.setVariant(Variant.Danger);
badge.setPill(true);
badge.setPulse(true);
badge.setText("3");
\`\`\``;
}
